<template>
<g>
<path :style="{fill: $attrs.fgColor}" stroke="#f4a0ab" stroke-width="2.00" fill="none" stroke-linecap="butt" vector-effect="non-scaling-stroke" d="
  M 640.35 397.62
  Q 650.20 389.60 660.62 377.84
  C 664.82 373.10 666.41 367.43 663.03 361.97
  Q 661.25 359.09 655.50 355.31
  Q 648.21 350.51 641.00 345.18
  C 634.02 340.01 627.41 341.00 621.76 347.38
  C 577.78 397.04 499.76 397.45 455.74 347.75
  C 449.62 340.84 443.49 339.87 435.71 345.41
  Q 426.41 352.03 417.87 357.98
  Q 411.70 362.27 412.43 369.96
  C 412.77 373.55 415.15 376.23 417.42 378.81
  C 475.02 444.39 572.75 452.69 640.35 397.62"
/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 628.93 593.60
  Q 612.41 597.03 597.34 597.04
  Q 472.95 597.10 343.56 597.06
  C 329.34 597.06 320.15 586.66 320.15 573.03
  Q 320.12 377.06 320.05 183.72
  C 320.04 170.26 329.48 159.93 343.00 159.93
  Q 465.38 159.94 587.75 159.93
  Q 601.50 159.92 607.74 160.39
  C 685.95 166.27 749.48 227.99 756.41 306.73
  Q 757.21 315.85 757.18 326.36
  Q 757.03 379.49 757.17 432.70
  Q 757.33 493.64 719.50 539.13
  C 696.56 566.71 664.40 586.23 628.93 593.60
  Z
  M 640.35 397.62
  Q 650.20 389.60 660.62 377.84
  C 664.82 373.10 666.41 367.43 663.03 361.97
  Q 661.25 359.09 655.50 355.31
  Q 648.21 350.51 641.00 345.18
  C 634.02 340.01 627.41 341.00 621.76 347.38
  C 577.78 397.04 499.76 397.45 455.74 347.75
  C 449.62 340.84 443.49 339.87 435.71 345.41
  Q 426.41 352.03 417.87 357.98
  Q 411.70 362.27 412.43 369.96
  C 412.77 373.55 415.15 376.23 417.42 378.81
  C 475.02 444.39 572.75 452.69 640.35 397.62
  Z"
/>
<path fill="none" d="
  M 640.35 397.62
  C 572.75 452.69 475.02 444.39 417.42 378.81
  C 415.15 376.23 412.77 373.55 412.43 369.96
  Q 411.70 362.27 417.87 357.98
  Q 426.41 352.03 435.71 345.41
  C 443.49 339.87 449.62 340.84 455.74 347.75
  C 499.76 397.45 577.78 397.04 621.76 347.38
  C 627.41 341.00 634.02 340.01 641.00 345.18
  Q 648.21 350.51 655.50 355.31
  Q 661.25 359.09 663.03 361.97
  C 666.41 367.43 664.82 373.10 660.62 377.84
  Q 650.20 389.60 640.35 397.62
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 166.11 852.68
  Q 161.76 858.61 157.49 864.03
  C 155.98 865.95 153.52 866.62 151.19 866.62
  Q 130.64 866.63 114.14 866.63
  C 88.58 866.64 66.71 849.79 60.62 824.98
  Q 58.98 818.29 59.05 807.16
  Q 59.15 790.33 59.15 777.12
  Q 59.15 755.75 73.07 740.35
  Q 89.39 722.29 114.76 722.25
  Q 140.58 722.20 166.07 722.26
  Q 166.68 722.27 166.68 721.65
  Q 166.68 700.77 166.68 679.79
  C 166.68 673.70 171.05 671.51 176.68 671.61
  Q 186.92 671.79 194.52 671.66
  C 200.14 671.57 203.55 674.59 203.55 679.88
  Q 203.61 773.00 203.57 858.41
  C 203.56 863.81 199.86 866.67 194.85 866.65
  Q 183.60 866.59 174.67 866.64
  C 169.45 866.67 166.46 862.56 166.63 857.67
  Q 166.72 855.26 166.68 852.86
  Q 166.67 851.93 166.11 852.68
  Z
  M 96.03 811.79
  C 96.06 819.13 99.88 825.30 106.63 828.29
  Q 110.17 829.87 117.43 829.82
  Q 142.56 829.67 166.38 829.78
  A 0.30 0.30 0.0 0 0 166.68 829.48
  L 166.68 759.74
  Q 166.68 759.13 166.07 759.13
  Q 139.58 759.12 114.09 759.12
  C 104.14 759.13 96.07 766.62 96.02 776.57
  Q 95.95 792.44 96.03 811.79
  Z"
/>
<rect :style="{fill: $attrs.fgColor}" fill="#e94157" x="-18.44" y="-16.60" transform="translate(244.70,688.28) rotate(0.1)" width="36.88" height="33.20" rx="7.73"/>
<rect :style="{fill: $attrs.fgColor}" fill="#e94157" x="-18.44" y="-16.60" transform="translate(471.44,688.30) rotate(0.1)" width="36.88" height="33.20" rx="7.73"/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 549.42 801.29
  Q 549.40 829.79 549.45 858.21
  C 549.46 864.21 545.51 866.74 539.95 866.69
  Q 529.21 866.60 520.91 866.61
  C 515.35 866.62 512.56 863.09 512.56 857.93
  Q 512.50 767.27 512.61 679.48
  C 512.62 674.75 516.13 671.65 520.75 671.67
  Q 532.14 671.71 541.73 671.67
  C 546.12 671.65 549.42 675.20 549.42 679.56
  Q 549.45 733.76 549.42 787.99
  Q 549.42 788.87 549.95 788.17
  Q 573.70 756.99 598.01 725.10
  Q 600.15 722.29 604.07 722.27
  Q 618.83 722.23 634.30 722.24
  C 636.83 722.24 638.93 722.22 640.47 724.60
  C 641.80 726.64 641.50 728.93 640.08 730.79
  Q 615.52 763.01 591.64 794.38
  A 0.62 0.61 -45.5 0 0 591.64 795.13
  Q 615.00 825.81 639.84 858.48
  C 641.85 861.12 640.58 864.99 637.66 866.14
  Q 636.25 866.70 634.11 866.68
  Q 618.77 866.56 604.32 866.68
  Q 599.91 866.72 597.57 863.69
  Q 573.87 833.02 549.83 801.15
  Q 549.42 800.62 549.42 801.29
  Z"
/>
<rect :style="{fill: $attrs.fgColor}" fill="#e94157" x="816.62" y="671.72" width="36.88" height="194.94" rx="7.74"/>
<rect :style="{fill: $attrs.fgColor}" fill="#e94157" x="226.25" y="722.13" width="36.88" height="144.50" rx="7.75"/>
<rect :style="{fill: $attrs.fgColor}" fill="#e94157" x="453.00" y="722.12" width="36.88" height="144.50" rx="7.76"/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 393.11 736.13
  Q 393.18 733.76 393.09 731.06
  C 392.90 726.01 396.05 722.23 401.27 722.25
  Q 410.68 722.29 421.61 722.21
  C 426.59 722.17 430.31 725.18 430.31 730.38
  Q 430.34 799.42 430.32 865.61
  C 430.31 896.57 406.56 920.88 375.53 920.99
  Q 360.67 921.04 347.45 920.98
  Q 343.71 920.97 341.17 917.61
  Q 331.75 905.14 322.61 893.04
  C 320.15 889.79 322.12 884.14 326.54 884.13
  Q 350.51 884.08 373.24 884.17
  Q 379.03 884.19 382.19 882.89
  Q 392.17 878.77 393.44 867.41
  Q 393.53 866.62 392.74 866.62
  Q 365.17 866.64 340.98 866.63
  C 309.84 866.61 285.62 842.29 285.82 811.16
  Q 285.90 798.62 285.75 782.78
  Q 285.64 771.32 287.26 764.38
  C 293.12 739.34 315.06 722.33 340.49 722.28
  Q 357.82 722.25 377.20 722.21
  C 380.49 722.20 382.85 723.19 384.81 725.85
  Q 388.78 731.24 392.67 736.28
  Q 393.09 736.83 393.11 736.13
  Z
  M 393.38 829.41
  L 393.38 759.47
  A 0.39 0.39 0.0 0 0 392.99 759.08
  L 341.01 759.08
  A 18.33 17.97 0.0 0 0 322.68 777.05
  L 322.68 811.83
  A 18.33 17.97 0.0 0 0 341.01 829.80
  L 392.99 829.80
  A 0.39 0.39 0.0 0 0 393.38 829.41
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 756.10 852.76
  Q 751.92 858.37 748.04 863.43
  Q 745.53 866.69 741.47 866.65
  Q 727.28 866.50 711.66 866.70
  Q 698.62 866.86 691.86 865.28
  C 670.99 860.39 655.11 844.30 650.67 823.48
  Q 649.20 816.59 649.45 805.35
  Q 649.70 794.30 649.45 784.41
  Q 649.16 772.56 650.78 764.96
  C 655.33 743.66 672.24 727.54 693.57 723.27
  Q 699.39 722.11 712.86 722.17
  Q 751.26 722.35 785.46 722.22
  C 791.72 722.20 794.01 726.28 794.00 731.98
  Q 793.81 795.47 793.99 857.03
  C 794.01 862.72 791.45 866.72 785.62 866.65
  Q 776.41 866.54 766.20 866.70
  Q 762.20 866.76 759.98 865.19
  C 755.86 862.30 756.72 857.48 756.70 852.96
  Q 756.69 851.96 756.10 852.76
  Z
  M 757.07 829.45
  L 757.07 759.43
  A 0.31 0.31 0.0 0 0 756.76 759.12
  L 704.12 759.12
  A 17.73 17.47 -0.0 0 0 686.39 776.59
  L 686.39 812.29
  A 17.73 17.47 0.0 0 0 704.12 829.76
  L 756.76 829.76
  A 0.31 0.31 0.0 0 0 757.07 829.45
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#e94157" d="
  M 983.86 852.75
  Q 979.94 857.97 975.99 863.19
  Q 973.35 866.69 969.21 866.65
  Q 954.71 866.52 937.42 866.70
  Q 924.58 866.84 917.27 864.97
  C 897.36 859.88 882.04 844.13 877.56 824.22
  Q 875.94 817.02 876.09 805.46
  Q 876.27 792.12 876.17 778.27
  C 875.97 751.23 893.79 728.38 920.32 723.25
  Q 926.31 722.10 940.15 722.16
  Q 976.53 722.33 1012.71 722.23
  C 1017.54 722.21 1020.62 725.82 1020.62 730.52
  Q 1020.70 792.77 1020.59 858.59
  C 1020.58 864.11 1016.66 866.77 1011.50 866.68
  Q 1002.71 866.53 993.53 866.68
  C 987.78 866.78 984.24 863.49 984.39 857.54
  Q 984.45 855.26 984.44 852.94
  Q 984.44 851.98 983.86 852.75
  Z
  M 983.75 759.74
  Q 983.75 759.08 983.09 759.09
  Q 958.58 759.22 934.76 759.05
  Q 927.88 759.00 924.50 760.29
  C 917.24 763.06 912.96 769.78 913.03 777.52
  Q 913.19 792.92 912.99 806.50
  Q 912.88 814.79 914.06 817.94
  C 917.36 826.69 924.37 829.87 933.47 829.82
  Q 957.75 829.67 983.43 829.79
  A 0.32 0.32 0.0 0 0 983.75 829.47
  L 983.75 759.74
  Z"
/>
ill="#fd564a" fill-opacity="0.988" d="   M 148.27 76.93   L 148.27 62.04   A 0.89 0.88 90.0 0 1 149.15 61.15   L 179.58 61.15   A 0.74 0.73 -88.9 0 1 180.31 61.92   L 179.92 69.82   A 3.47 3.37 55.5 0 1 179.78 70.64   Q 178.61 74.63 174.75 76.49   Q 172.45 77.60 167.07 77.55   Q 150.39 77.40 148.98 77.57   A 0.64 0.64 0.0 0 1 148.27 76.93   Z"></path>
</g>
</template>

<script>
export default {
  name: "svgDigikala"
}
</script>